
export default {

    index: function(params = {}){
        return window.axios.get('/api/service-products', {
            params: params,
        });
    },

    get: function (id) {
        return window.axios.get('/api/service-products/'+id);
    },

    create: function(product){
        return window.axios.post('/api/service-products', product);
    },

    update: function (product) {
        return window.axios.put('/api/service-products/'+product.id, product);
    },
    delete: function(product){
        return window.axios.delete('/api/service-products/'+product.id);
    },

}


// WEBPACK FOOTER //
// ./resources/assets/js/services/ServiceProductsService.js